// oxlint-disable graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import {
	ApolloErrorInterop,
	isApolloError,
} from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';

/** Relay may reject null-data responses with a GraphQL array or a RelayNetwork error. */
export function normalizeRelayError(error: Error): ApolloErrorInterop;
export function normalizeRelayError(error: unknown): unknown;
export function normalizeRelayError(error: unknown): unknown {
	// A normalized failure also exposes source.errors; do not unwrap it and lose network context.
	if (isApolloError(error)) {
		return error;
	}
	if (Array.isArray(error)) {
		return new ApolloErrorInterop({ graphQLErrors: error });
	}
	if (
		error instanceof Error &&
		'source' in error &&
		typeof error.source === 'object' &&
		error.source !== null &&
		'errors' in error.source &&
		Array.isArray(error.source.errors)
	) {
		return new ApolloErrorInterop({ graphQLErrors: error.source.errors });
	}
	return error instanceof Error && !isApolloError(error)
		? new ApolloErrorInterop({ networkError: error })
		: error;
}
